export const InputDefault = ({ id, label, subLabel, type, inputMode, placeholder, value, onChange, error, disabled }) => {
    return (
        <div className="w-full flex flex-col">
            <label
                htmlFor={id}
                className="block text-[11px] font-semibold text-slate-400 mb-1.5"
            >
                {label} {subLabel && <span className="text-[10px] text-slate-500">({subLabel})</span>}
            </label>
            <input
                id={id}
                type={type ?? "text"}
                inputMode={inputMode ?? "text"}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                disabled={disabled}
                className="w-full px-4 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all"
            />
            {error && (
                <span className="text-xs text-red-600 font-medium mt-1 block">
                    {error}
                </span>
            )}
        </div>
    )
}